<template>
  <ModalBase :state="state" :open="open" :close="close" @before-show="onShow">
    <template #header>
      <HeaderModalSolicitacao
        :data="state.row.data_criacao"
        :title="state.grupo"
        :user="state.row.usuario_serializado"
        @click:close="close"
      />
    </template>
    <template #content>
      <OTabs
        v-model="tabs"
        :loading="false"
        :show-icon="false"
        :tabs="tabsArr"
      />

      <q-tab-panels
        key="tabs"
        v-model="tabs"

        class="QTab flex-1 h-full dark:bg-d-neutral-20 rounded-xl flex flex-col"
      >
        <q-tab-panel name="comentarios" class="!h-auto ">
          <!-- CONTEUDO TAB 1-->
          <OChatBoxSolicitacao :row-id="state.row.id" />
        </q-tab-panel>

        <q-tab-panel name="historico" class="!h-auto flex ">
          <!-- CONTEUDO TAB 2-->
          <!-- <OHistorico class="flex-1" /> -->
          <TabHistorico class="flex-1 " :row-id="state.row.id" />
        </q-tab-panel>

        <q-tab-panel name="uploads" class="!h-auto ">
          <section class="p-24">
            <!-- CONTEUDO TAB 3-->
            <TabUploads :row="state.row" />
          </section>
        </q-tab-panel>
      </q-tab-panels>
    </template>
  </ModalBase>
</template>

<script setup>
import { api, URLS } from 'js/modules/axios'
import { computed, inject, ref, watch } from 'vue'
import { useSessionStorage } from '@vueuse/core'
import HeaderModalSolicitacao from 'components/Header/HeaderModalSolicitacao.vue'
import ModalBase from './ModalBase.vue'
import OButton from 'components/Button/OButton.vue'
import OChatBoxSolicitacao from 'components/Chat/OChatBoxSolicitacao.vue'
import OTabs from 'components/Tabs/OTabs.vue'
import TabHistorico from 'components/ModalSolicitacao/TabHistorico.vue'
import TabUploads from 'components/ModalSolicitacao/TabUploads.vue'
import useModal from 'composables/useModal'

import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const modalSolicitacao = useModal({
  header_default: false,
  style: { width: '700px' },
  contentClass: '!p-0',
})

const { state, open, close } = modalSolicitacao

const tabs = ref('comentarios')

const tabsArr = computed(() => [
  {
    name: 'comentarios',
    label: t('comments'),
    icon: 'chat_bubble',
  },
  {
    name: 'historico',
    label: t('history'),
    icon: 'history',
  },
  {
    name: 'uploads',
    label: t('uploads'),
    icon: 'upload',
  },
])

function onShow() {
  if (state.value.tab) tabs.value = state.value.tab
}

const { modalAtencaoRef } = inject('modal')

const modalAtencaoStorage = useSessionStorage('modalAtencaoStorage', {
  uploads: false,
})

watch(
  () => tabs.value,
  (v) => {
    // if (v !== 'uploads') return
    // if (!modalAtencaoStorage.value.uploads) {
    //   modalAtencaoStorage.value.uploads = true
    //   modalAtencaoRef.value.open({
    //     local_exibicao: 'lista_solicitacoes',
    //   })
    // }
  }
)

defineExpose({
  state,
  open,
  close,
})
</script>

<style lang="scss" scoped>
.QTab {
  min-height: calc(100vh - 250px);
  :deep(.q-panel.scroll) {
    height: auto;
    display: flex !important;
    flex: 1;
  }
}
</style>
